// hooks/useActiveNav.ts
import { useLocation } from 'react-router';
import type { NavItem } from '@/utils/navigationItems';

export const useActiveNav = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isNavItemActive = (item: NavItem): boolean => {
    // Direct match for items with href
    if (item.href) {
      // Special case for home route
      if (item.href === '/' && currentPath === '/') {
        return true;
      }
      // For other routes, check if current path starts with the href
      // This handles nested routes like /benefits-verifications/*
      if (item.href !== '/' && currentPath.startsWith(item.href)) {
        return true;
      }
    }

    // Check submenu items recursively
    if (item.submenu) {
      return item.submenu.some(subItem => isNavItemActive(subItem));
    }

    return false;
  };

  const isParentOfActive = (item: NavItem): boolean => {
    if (!item.submenu) return false;
    
    return item.submenu.some(subItem => 
      isNavItemActive(subItem) || 
      (subItem.submenu && isParentOfActive(subItem))
    );
  };

  const getActiveState = (item: NavItem): 'active' | 'parent-active' | 'inactive' => {
    if (isNavItemActive(item)) return 'active';
    if (isParentOfActive(item)) return 'parent-active';
    return 'inactive';
  };

  return {
    isNavItemActive,
    isParentOfActive,
    getActiveState,
    currentPath
  };
};